import { Pipe, PipeTransform } from '@angular/core';
import { GanttDateService, GanttItem } from '../services';

@Pipe({
    name: 'ganttItemTooltip',
    standalone: false,
})
export class GanttItemTooltipPipe implements PipeTransform {
    public constructor(private readonly dateService: GanttDateService) {}

    public transform(item: GanttItem<unknown> | null | undefined): string {
        if (!item) return '';

        const fromDate = item.from
            ? this.dateService.formatTooltipDate(item.from)
            : '';
        const toDate = item.to
            ? this.dateService.formatTooltipDate(item.to)
            : '';

        if (fromDate && toDate) return `${fromDate} - ${toDate}`;
        if (fromDate) return `Start: ${fromDate}`;
        if (toDate) return `End: ${toDate}`;

        return item.name ?? '';
    }
}
